import { EN_TENANT_NAME } from '../../enums/tenant';
import { registerPlugin } from '../../plugins/plugin_register';
import { DefaultRegistry } from '../default_registry';
import { registerTenantConfig } from '../register';

@registerTenantConfig(EN_TENANT_NAME.Thyssenkrupp)
export class ThyssenkruppTenantRegistry extends DefaultRegistry {
  static async register(): Promise<void> {
    // super.register();
    const { ProjectionSettingReplenisherThyssenkrupp } = await import(
      '../../plugins/service_plugins/projection_setting_replenisher/projection_setting_replenisher_Thyssenkrupp'
    );
    registerPlugin(ProjectionSettingReplenisherThyssenkrupp);

    const { DefaultProjectionSettingConfigProviderDisen } = await import(
      '../../plugins/service_plugins/default_projection_setting_config_provider/default_projection_setting_config_provider_disen'
    );
    registerPlugin(DefaultProjectionSettingConfigProviderDisen);
    
    const { UIConfig蒂森 } = await import(
      '../../plugins/service_plugins/ui_config/ui_config_disen'
    );
    registerPlugin(UIConfig蒂森);
  }
}
